import React from 'react'
import { Logo, Slogan } from '@assets/logos'

import Container from '@components/Container'
import Image from '@components/Image'

import * as Style from './Footer.style'

export default function Footer() {
  return (
    <Style.FooterWrapper>
      <Container>
        <Style.FooterContent>
          <Style.LogoWrapper>
            <Image src={Logo} alt="Gympass written in orange" />
            <Image
              src={Slogan}
              alt='The gympass slogan "helping people find an activity to love" written in grey letter with helping people in bold font'
            />
          </Style.LogoWrapper>

          <Style.TextTiny>
            &copy; 2012-{new Date().getFullYear()} GPBR Part Ltda. - Todos os
            direitos reservados.
          </Style.TextTiny>
        </Style.FooterContent>
      </Container>
    </Style.FooterWrapper>
  )
}
